<h3-navbar [stepId]="stepId">
  <h3-steps-navigation
    [stepId]="stepId"
    projection-location="left"
  ></h3-steps-navigation>
  <div class="right-navbar-section" projection-location="right">
    @if (!templateId) {
      <h3-timer-badge></h3-timer-badge>
      <h3-pause-task-button></h3-pause-task-button>
    }
    @if (navbarSubmitEnabled) {
      <h3-submit-task-button
        [withConfirmation]="!templateId"
      ></h3-submit-task-button>
    } @else if (!templateId) {
      <h3-stop-work-button></h3-stop-work-button>
    }
  </div>
  <ng-container projection-location="breadcrumbs">
    @if (isSaving$ | async) {
      <h3-saving-indicator></h3-saving-indicator>
    } @else {
      @if (isUsingObjects) {
        <h3-last-saved-badge> </h3-last-saved-badge>
      } @else {
        <h3-objectless-last-saved-badge> </h3-objectless-last-saved-badge>
      }
    }
  </ng-container>
</h3-navbar>
